import React, { useEffect, useRef } from 'react'
import { editVhndUhndProps } from '../vhnd-interface';
import Unauthorised from '@components/Auth/Unauthorised';
import dayjs from 'dayjs';
import { status_type } from '@constants/sessionSiteConstant';
import { dateFormate } from '@constants/index';

const EditDuplicateVhndUhndWrapper = ({ sessionDetail, flow, children }: editVhndUhndProps) => {
    const hasPermission = useRef<boolean>(true);

    useEffect(() => {
        if (flow == 'edit') {
            const sessionDate = dayjs(dayjs(sessionDetail?.session_planned_date).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
            const currentDate = dayjs(dayjs(new Date()).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
            const checkDate = ((sessionDetail?.session_status_code == status_type.cancle.session_status_code)
                || sessionDate.isBefore(currentDate)) ? true : false;
            hasPermission.current = !checkDate;
        }

    }, [flow]);

    return <>{hasPermission.current ? children : <Unauthorised />}</>;
}

export default EditDuplicateVhndUhndWrapper;